/**
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 *
 * CustomTab Component
 *
 * Renders a customizable tab with an icon, title, and a number indicator.
 * The tab highlights when selected and triggers an onClick event.
 *
 * @component
 *
 * @param {Object} props - Component props
 * @param {string|number} props.id - Unique identifier for the tab.
 * @param {string} props.title - The text displayed as the tab's title.
 * @param {number|string} props.newsNumber - The numeric or string badge shown inside the tab.
 * @param {JSX.Element} props.icon - Icon element displayed on the left side of the title.
 * @param {boolean} props.selected - Indicates if the tab is currently selected.
 * @param {function} [props.onClick=() => {}] - Callback executed when the tab is clicked.
 *
 * @returns {JSX.Element} Rendered CustomTab component.
 */

const CustomTab = ({ id, key, title, newsNumber, icon, selected, onClick = () => { } }) => {
    const showBadgeNumber = newsNumber === 0 || newsNumber;
    return (
        <div
            id={id}
            key={key}
            className={`d-flex gap-2 justify-content-center align-items-center py-1 custom-tab-container border-radius-8px ${selected ? "custom-tab-selected cursor-pointer" : ""
                }`}
            onClick={onClick}
        >
            <div className={`d-flex gap-2 cursor-pointer ${(showBadgeNumber) ? 'ml-2' : 'mx-2'} `}>
                <div>{icon}</div>
                <p className="mb-0 ibl-font-w-600 text-nowrap">{title}</p>
            </div>
            {(showBadgeNumber) &&
                <div className="custom-tab-news-number d-flex mr-2 justify-content-center align-items-center border-radius-8px cursor-pointer minw-18px">
                    {newsNumber}
                </div>
            }
        </div>
    );
}

CustomTab.displayName = "CustomTab";

export default CustomTab;

